/**
 * What a node icon's material draws with. Godot multiplies the albedo by the vertex colour that
 * carries the light tint, and converts both from sRGB (`node_3d_editor_gizmos.cpp:949-962`).
 */
import { godotColorToLinear } from '../godotColor';
import { INSTANTIATED_GIZMO_COLOUR } from '../gizmo/gizmoVariant';
const WHITE = { r: 1, g: 1, b: 1, a: 1 };
/** An unselected icon multiplies the colour channels by 0.6 and keeps the alpha (`:962-965`). */
const UNSELECTED_COLOUR_FACTOR = 0.6;
/** White, or the instantiated grey in a node the edited scene does not own, dimmed when unselected. */
function iconAlbedo(variant, isInstantiated) {
    const albedo = isInstantiated ? INSTANTIATED_GIZMO_COLOUR : WHITE;
    if (variant === 'selected')
        return albedo;
    const { r, g, b, a } = albedo;
    return {
        r: r * UNSELECTED_COLOUR_FACTOR,
        g: g * UNSELECTED_COLOUR_FACTOR,
        b: b * UNSELECTED_COLOUR_FACTOR,
        a,
    };
}
/** `modulate` is the vertex colour of the quad, white for a node that tints nothing. */
export function iconAppearance(variant, isInstantiated, modulate = WHITE) {
    const albedo = iconAlbedo(variant, isInstantiated);
    return {
        color: godotColorToLinear(albedo).multiply(godotColorToLinear(modulate)),
        opacity: albedo.a * modulate.a,
    };
}
//# sourceMappingURL=iconAppearance.js.map